import { Validate } from '@edgvr-front/util/validate';
import { BinaryFile1, BinaryInstance, BinaryVersion } from '../interface';
import { binaryFile1, binaryInstance, binaryVersion } from '../schema';

export class BinaryCreateCmd {
  private static configValidation = Validate.compile(
    BinaryCreateCmd.configValidationSchema()
  );

  constructor(readonly value: BinaryCreateCmdRaw) {
    Validate.assert(BinaryCreateCmd.configValidation, this.value);
  }

  private static configValidationSchema() {
    return {
      type: 'object',
      required: ['instance', 'version', 'file'],
      properties: {
        instance: binaryInstance,
        version: binaryVersion,
        file: binaryFile1,
      },
      additionalProperties: false,
    };
  }
}

interface BinaryCreateCmdRaw {
  instance: BinaryInstance;
  version: BinaryVersion;
  file: BinaryFile1;
}
